import React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Menu, Space, Button, Image } from 'antd';
import { TwitterCircleFilled, FacebookFilled, InstagramFilled } from '@ant-design/icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Footer = function Footer() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "first-footer-section",
      style: {
        padding: "25px 0px",
        boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;"
      },
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 1,
            md: 2,
            sm: 3,
            xs: 5,
            children: /*#__PURE__*/_jsx(Image, {
              preview: false,
              src: "/drawables/cl.png",
              width: "130px"
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: 4,
            children: /*#__PURE__*/_jsx("div", {
              className: "footer-box"
            })
          })]
        })
      })
    })
  });
};
export default Footer;